import React from 'react';
import PayBillsConfirmationDF from '../components/SimulatorsComponents/DefualtSimulators/PayBillsConfirmationDF';

//= ========================================================================
const Sim_D04_PayBillsConfirmation = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <PayBillsConfirmationDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_D04_PayBillsConfirmation;
